import { render, staticRenderFns } from "./LevIcon.vue?vue&type=template&id=af298464&scoped=true"
import script from "./LevIcon.vue?vue&type=script&lang=js"
export * from "./LevIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af298464",
  null
  
)

export default component.exports